import { getAvailableCommands } from './commandRegistry.js';

function escapeRegex(value) {
    return value.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
}

export function parseSchemaCommand(command) {
    for (const definition of getAvailableCommands()) {
        const parameters = definition.parameters ?? [];
        if (!parameters.length && command === definition.template) {
            return { commandId: definition.id, parameters: {} };
        }
        let pattern = escapeRegex(definition.template);
        for (const parameter of parameters) {
            pattern = pattern.replace(escapeRegex(`{{${parameter.id}}}`), '([\\s\\S]+)');
        }
        const match = command.match(new RegExp(`^${pattern}$`));
        if (!match) continue;
        return {
            commandId: definition.id,
            parameters: Object.fromEntries(parameters.map((parameter, index) => [parameter.id, match[index + 1]])),
        };
    }
    return null;
}

export function initialCommandParameters(commandId) {
    const definition = getAvailableCommands().find(command => command.id === commandId);
    return Object.fromEntries((definition?.parameters ?? []).map(parameter => [parameter.id, parameter.default ?? '']));
}

